import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import VisualizeObjectives from 'frontend/components/program-year/visualize-objectives';
<template>
  {{pageTitle (t "general.programs")}}
  <VisualizeObjectives @model={{@model}} />
</template>
